import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, ArrowUpRight, Check, Instagram } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/wyeeJtwvu1HiXsJKfGXny6/1.png';
const ICE_IMAGE = 'https://cdn.magicpatterns.com/uploads/knKE32EsZkYsqPa1ui7YrB/DSC03885.jpg';
const VIDEO_MOMENT = 'https://cdn.magicpatterns.com/uploads/macVvEoEwdpGBSYDC8PDiv/CPSTHLM_30.mp4';
const CAN_IMAGE = 'https://cdn.magicpatterns.com/uploads/wDu3fKhK1RBeGFe1tY72ry/DSC03888.jpg';
const PEOPLE_IMAGE_1 = 'https://cdn.magicpatterns.com/uploads/1KzvTsy3KfZ88WPDkaVLMn/WAGHORN_2026-03-22_18.jpg';
const PEOPLE_IMAGE_2 = 'https://cdn.magicpatterns.com/uploads/oLZUyGYJTdHH83PscaSwsS/IMG_0700.jpg';
const ICE_BOWL_IMAGE = 'https://cdn.magicpatterns.com/uploads/p4Sk3dNMD8P9BQwDabDdK8/DSC04025.jpg';
const INSTAGRAM_URL = 'https://www.instagram.com/beatyourbest_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==';
const CONTACT_EMAIL = 'info@beatsoda.com';
const WEB3FORMS_KEY = 'a23b9419-6869-4092-bd1e-0a48a2461c5e';
const EASE = [0.23, 1, 0.32, 1] as const;
const rise = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: EASE
    }
  }
};
const stagger = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.05
    }
  }
};
const WORLD_WORDS = ['MUSIC', 'FOOD', 'FRIENDS', 'TRAVEL', 'SPORT', 'ART', 'NIGHTLIFE', 'DESIGN', 'ADVENTURE'];
const INGREDIENTS = ['Beetroot', 'Grapefruit', 'Pomegranate', 'Lemon', 'Elderflower', 'Apple Cider Vinegar'];
export function LandingPage() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="w-full bg-beat-black font-sans text-white antialiased" data-id="element-1" data-mp="1lv7r7eqbafqv">
      {/* ── HERO ─────────────────────────────────────────────── */}
      <section className="relative min-h-screen w-full overflow-hidden" data-id="element-2" data-mp="3shdjvrrivc6m">
        <motion.img src={ICE_IMAGE} alt="A cold BEAT can buried in crushed ice" initial={{
        opacity: 0,
        scale: 1.06
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.4,
        ease: EASE
      }} className="absolute inset-0 h-full w-full object-cover object-center" data-id="element-3" data-mp="3nian0ulp4c9q" />
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(to top, rgba(10,10,10,0.88) 0%, rgba(10,10,10,0.45) 45%, rgba(10,10,10,0.12) 75%, rgba(255,255,255,0.35) 100%)'
      }} data-id="element-4" data-mp="34qrlytb8f8ac" />

        <BeatMark className="absolute left-5 top-8 z-20 w-28 md:left-10 md:top-10 md:w-32" data-id="element-5" data-mp="y0tjkclecutj" />

        <motion.div initial="hidden" animate="visible" variants={stagger} className="relative z-10 flex min-h-screen flex-col justify-end px-5 pb-20 pt-40 md:px-10 md:pb-24" data-id="element-6" data-mp="tzrg1jkg5wlr">
          <motion.p variants={rise} className="mb-6 text-[11px] font-bold uppercase tracking-[0.32em] text-white/70 md:text-xs" data-id="element-7" data-mp="2gv61skjfwapv">
            Good taste · Good people · Good times
          </motion.p>

          <motion.h1 variants={rise} className="max-w-[16ch] text-[13vw] font-black uppercase leading-[0.86] tracking-[-0.03em] md:max-w-[18ch] md:text-[8.5vw]" data-id="element-8" data-mp="2pnq2rrn7erdv">
            A better way to
            <br data-id="element-9" data-mp="21yx6fu2o6hiq" />
            experience <span className="text-beat-red" data-id="element-10" data-mp="21yno8snv9enl">life.</span>
          </motion.h1>

          <motion.div variants={rise} className="mt-10 flex flex-col gap-6 sm:flex-row sm:items-center" data-id="element-11" data-mp="26xryznqfvkg1">
            <button onClick={() => scrollTo('product')} className="group inline-flex items-center gap-3 bg-beat-red px-8 py-4 text-sm font-bold uppercase tracking-[0.18em] text-white transition-colors duration-150 hover:bg-white hover:text-beat-black" style={{
            transitionTimingFunction: 'cubic-bezier(0.23,1,0.32,1)'
          }} data-id="element-12" data-mp="3ddaq0mqe4asy">
              Discover BEAT
              <ArrowUpRight size={18} className="transition-transform duration-150 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" data-id="element-13" data-mp="3pud414kjwvg6" />
            </button>
            <p className="max-w-xs text-sm uppercase tracking-[0.16em] text-white/60" data-id="element-14" data-mp="3uvspuyujz5zm">
              A sober soda, done right.
            </p>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.6,
        duration: 0.6
      }} className="absolute bottom-8 right-5 z-10 text-white/50 md:right-10" data-id="element-15" data-mp="dhdw94dir7p6">
          <ArrowDown size={22} className="animate-bounce" data-id="element-16" data-mp="112ogn80ptbzi" />
        </motion.div>
      </section>

      {/* ── 02: THIS IS BEAT (PRODUCT) ───────────────────────── */}
      <section id="product" className="border-b border-white/10 px-5 py-24 md:px-10 md:py-36" data-id="element-17" data-mp="160zsfoaklwkd">
        <div className="mx-auto grid max-w-[1400px] items-center gap-14 lg:grid-cols-2 lg:gap-20" data-id="element-18" data-mp="s4ci8jtlx9wi">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} variants={stagger} data-id="element-19" data-mp="w5fxb43tz1wo">
            <motion.p variants={rise} className="mb-8 text-[11px] font-bold uppercase tracking-[0.32em] text-beat-red" data-id="element-20" data-mp="8eafwki8s1k9">
              The Drink
            </motion.p>
            <motion.h2 variants={rise} className="text-[11vw] font-black uppercase leading-[0.88] tracking-[-0.03em] md:text-[5.6vw]" data-id="element-21" data-mp="3vi6xbubrdyj9">
              This is BEAT.
            </motion.h2>
            <motion.p variants={rise} className="mt-8 max-w-md text-lg leading-relaxed text-white/60" data-id="element-22" data-mp="262cycxdx3nni">
              A drink for the moments worth remembering. Bright, bold, rewarding, and balanced.
            </motion.p>

            <motion.div variants={rise} className="mt-12 flex items-center gap-4" data-id="element-23" data-mp="1saq2gynw0h59">
              <div className="h-4 w-4 rounded-full bg-beat-red" data-id="element-24" data-mp="2p0gtgnwyzm6b" />
              <span className="text-sm font-bold uppercase tracking-[0.18em]" data-id="element-25" data-mp="2oznx8gvn0f2f">Red</span>
              <div className="h-4 w-4 rounded-full bg-yellow-400" data-id="element-26" data-mp="2k1vv6u1a3cki" />
              <span className="text-sm font-bold uppercase tracking-[0.18em]" data-id="element-27" data-mp="2fyzj7m68uepj">Yellow</span>
              <div className="h-4 w-4 rounded-full bg-white" data-id="element-28" data-mp="2b17f7tsbr24z" />
              <span className="text-sm font-bold uppercase tracking-[0.18em]" data-id="element-29" data-mp="2b2sa5kijwn3d">White</span>
            </motion.div>

            <motion.button variants={rise} className="mt-12 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[0.18em] text-beat-red transition-colors hover:text-white" data-id="element-30" data-mp="zlirv1b5s13n">
              Discover the flavours <ArrowUpRight size={16} data-id="element-31" data-mp="3g8qu4bzts6pw" />
            </motion.button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 28
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.8,
          ease: EASE
        }} className="relative aspect-[4/5] w-full overflow-hidden" data-id="element-32" data-mp="3k8hpkt0arb0r">
            <img src={CAN_IMAGE} alt="A BEAT can resting on a railing" className="h-full w-full object-cover" data-id="element-33" data-mp="bth8eu2lhmrt" />
          </motion.div>
        </div>
      </section>

      {/* ── MARQUEE ──────────────────────────────────────────── */}
      <Marquee data-id="element-34" data-mp="1uovgwdq85vqg" />

      {/* ── 03: THE WORLD ────────────────────────────────────── */}
      <section id="world" className="border-b border-white/10 px-5 py-24 md:px-10 md:py-36" data-id="element-35" data-mp="1umispitvip4y">
        <div className="mx-auto max-w-[1400px]" data-id="element-36" data-mp="1pno7ybcciqi7">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} variants={stagger} className="grid gap-14 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.6fr)] lg:gap-20" data-id="element-37" data-mp="23g45wxqe3yc9">
            <div data-id="element-38" data-mp="16s7vybpgk1a0">
              <motion.p variants={rise} className="mb-8 text-[11px] font-bold uppercase tracking-[0.32em] text-beat-red" data-id="element-39" data-mp="16sr450pb3bau">
                The World
              </motion.p>
              <motion.p variants={rise} className="text-2xl font-medium leading-snug text-white md:text-3xl" data-id="element-40" data-mp="1ftxm7e7lsu67">
                BEAT lives where good people, good taste and good experiences
                meet.
              </motion.p>
              <motion.p variants={rise} className="mt-8 max-w-sm text-base leading-relaxed text-white/50" data-id="element-41" data-mp="2zpv3k68lzl75">
                A dinner. A festival. A studio. A beach. A basement bar at 1am.
                The place changes. The feeling doesn't.
              </motion.p>
            </div>

            <motion.div variants={rise} data-id="element-42" data-mp="3iei7umiyo6jo">
              <ul className="flex flex-wrap items-baseline gap-x-6 gap-y-2" data-id="element-43" data-mp="3ifkziwo3yd0n">
                {WORLD_WORDS.map(word => <li key={word} className="text-[9vw] font-black uppercase leading-[0.9] tracking-[-0.03em] text-white/85 md:text-[4.6vw]" data-id="element-44" data-mp="3nfflqmwxuefd">
                    {word}
                    <span className="text-beat-red" data-id="element-45" data-mp="57zzgr91fw2y">.</span>
                  </li>)}
              </ul>
              <p className="mt-12 text-3xl font-black uppercase tracking-[-0.02em] text-beat-red md:text-5xl" data-id="element-46" data-mp="9yq2vyxwlov0">
                Something is happening.
              </p>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* ── 04: PEOPLE WITH A BEAT ───────────────────────────── */}
      <section className="bg-white px-5 py-24 text-beat-black md:px-10 md:py-36" data-id="element-47" data-mp="241s8wceravrp">
        <div className="mx-auto max-w-[1400px]" data-id="element-48" data-mp="29154pmnlvd6f">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} variants={stagger} className="grid gap-16 lg:grid-cols-2 lg:gap-24" data-id="element-49" data-mp="29413fd7a25vx">
            <div data-id="element-50" data-mp="1ldwwowyslq0p">
              <motion.p variants={rise} className="mb-8 text-[11px] font-bold uppercase tracking-[0.32em] text-beat-red" data-id="element-51" data-mp="1la97ub4alrsb">
                People with a beat
              </motion.p>
              <motion.h2 variants={rise} className="text-[10vw] font-black uppercase leading-[0.88] tracking-[-0.03em] md:text-[5.6vw]" data-id="element-52" data-mp="1gczg2otfl41b">
                BEAT belongs to people with their own taste.
              </motion.h2>

              <motion.div variants={stagger} className="mt-16 grid gap-10 border-t border-black/10 pt-12" data-id="element-53" data-mp="ruqqih7aqme3">
                <PeopleItem title="Create" copy="Ideas that land. Nights that stay sharp all the way to the end." data-id="element-54" data-mp="11pirlv037rdm" />
                <PeopleItem title="Connect" copy="Conversations you actually remember. Presence you can feel." data-id="element-55" data-mp="1ari3ya05q7a8" />
                <PeopleItem title="Move" copy="A body that shows up the next morning, ready to go again." data-id="element-56" data-mp="1pi7jfokni8jw" />
              </motion.div>
            </div>

            <motion.div variants={rise} className="grid grid-cols-2 gap-4 md:gap-6" data-id="element-57" data-mp="1yeq8gpprhcb7">
              <div className="mt-12 md:mt-24" data-id="element-58" data-mp="21io26o0qmkuv">
                <img src={PEOPLE_IMAGE_1} alt="Candid shot of a woman drinking BEAT at a party" className="aspect-[3/4] w-full object-cover" data-id="element-59" data-mp="21jz6qq20bwn1" />
              </div>
              <div data-id="element-60" data-mp="2ber53w3eyniv">
                <img src={PEOPLE_IMAGE_2} alt="Candid shot of a man drinking BEAT with sunglasses" className="aspect-[3/4] w-full object-cover" data-id="element-61" data-mp="2g7tya34a3uyj" />
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* ── 05: TASTE ────────────────────────────────────────── */}
      <section className="border-b border-white/10 px-5 py-24 md:px-10 md:py-36" data-id="element-62" data-mp="2z6687r30l8v6">
        <div className="mx-auto max-w-[1400px]" data-id="element-63" data-mp="2z43iz99orjri">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} variants={stagger} className="text-center" data-id="element-64" data-mp="ztu3f6kaivi5">
            <motion.p variants={rise} className="mb-8 text-[11px] font-bold uppercase tracking-[0.32em] text-beat-red" data-id="element-65" data-mp="3i49ctqmaasyo">
              Taste
            </motion.p>
            <motion.h2 variants={rise} className="mx-auto max-w-[18ch] text-[10vw] font-black uppercase leading-[0.88] tracking-[-0.03em] md:text-[5.6vw]" data-id="element-66" data-mp="34b0b8c4kvbqp">
              Flavor. Texture. Pairing. Moment.
            </motion.h2>
            
            <motion.ul variants={rise} className="mt-16 flex flex-wrap justify-center gap-x-4 gap-y-3 text-xs font-bold uppercase tracking-[0.18em] text-white/70 md:text-sm" data-id="element-67" data-mp="s6x9y7w0kw0">
              {INGREDIENTS.map((item, index) => <li key={item} className="flex items-center gap-4" data-id="element-68" data-mp="2gm8nbwy0tfjq" data-mpi={index}>
                  {index > 0 && <span className="text-beat-red" data-id="element-69" data-mp="2blb7hr0hgxle">·</span>}
                  {item}
                </li>)}
            </motion.ul>
          </motion.div>
        </div>
      </section>

      {/* ── 06: THE WORLD IN MOTION ──────────────────────────── */}
      <Moment src={VIDEO_MOMENT} alt="Bartender grabbing a BEAT can from an ice bowl" label="Club · 23:45" isVideo data-id="element-70" data-mp="3qicj9ls323o7" />

      {/* ── 07: THE STORY ────────────────────────────────────── */}
      <section className="px-5 py-24 md:px-10 md:py-36" data-id="element-71" data-mp="n1dsksu4zh0r">
        <div className="mx-auto max-w-[1400px]" data-id="element-72" data-mp="mzsy137tny2w">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} variants={stagger} className="grid gap-14 lg:grid-cols-2 lg:gap-20" data-id="element-73" data-mp="r27ghm7kwvtn">
            <div data-id="element-74" data-mp="2xt5h8ctf6vy7">
              <motion.p variants={rise} className="mb-8 text-[11px] font-bold uppercase tracking-[0.32em] text-beat-red" data-id="element-75" data-mp="2xsni98fdi3ml">
                The Story
              </motion.p>
              <motion.h2 variants={rise} className="text-[10vw] font-black uppercase leading-[0.88] tracking-[-0.03em] md:text-[5.6vw]" data-id="element-76" data-mp="2v7fn9mtclg2o">
                São Paulo &rarr; Stockholm &rarr; BEAT.
              </motion.h2>
            </div>
            <div className="flex flex-col justify-center" data-id="element-77" data-mp="2zc5id9g6mqmj">
              <motion.p variants={rise} className="text-lg leading-relaxed text-white/70 md:text-xl" data-id="element-78" data-mp="2bl03oxlza4dt">
                Someone tasted something amazing. They couldn't stop thinking about it. They brought the idea home. They met the right people. BEAT happened.
              </motion.p>
              <motion.p variants={rise} className="mt-6 text-lg leading-relaxed text-white/70 md:text-xl" data-id="element-79" data-mp="2gjbbl2spq4te">
                The moment matters more than the beet.
              </motion.p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ── MOMENT: ICE BOWL ─────────────────────────────────── */}
      <Moment src={ICE_BOWL_IMAGE} alt="A large metal bowl filled with ice and BEAT cans at an event" label="Backstage · 21:00" data-id="element-80" data-mp="3swhxp0uf7i9e" />

      {/* ── 08: JOIN ─────────────────────────────────────────── */}
      <section className="px-5 py-24 md:px-10 md:py-36" data-id="element-81" data-mp="6g5cnouu1iux">
        <div className="mx-auto max-w-[1400px]" data-id="element-82" data-mp="34zc7xdsxe19f">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} variants={stagger} className="mb-14 flex flex-col gap-8 md:flex-row md:items-end md:justify-between" data-id="element-83" data-mp="350nbpdmdf90j">
            <div data-id="element-84" data-mp="3iwr18tmaut6o">
              <motion.p variants={rise} className="mb-6 text-[11px] font-bold uppercase tracking-[0.32em] text-beat-red" data-id="element-85" data-mp="u71cn99fzkd9">
                Join
              </motion.p>
              <motion.h2 variants={rise} className="text-[12vw] font-black uppercase leading-[0.88] tracking-[-0.03em] md:text-[5.6vw]" data-id="element-86" data-mp="2iqf6l9y4og9b">
                Join the BEAT.
              </motion.h2>
            </div>
            <motion.a variants={rise} href={`mailto:${CONTACT_EMAIL}`} className="text-xl font-bold uppercase tracking-[-0.01em] text-white underline decoration-beat-red decoration-2 underline-offset-8 transition-colors duration-150 hover:text-beat-red md:text-3xl" data-id="element-87" data-mp="29wilzzkm3bw0">
              {CONTACT_EMAIL}
            </motion.a>
          </motion.div>

          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-60px'
        }} variants={stagger} className="grid gap-4 lg:grid-cols-3" data-id="element-88" data-mp="1qzr9c8zkrv0x">
            <motion.a variants={rise} href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="group flex flex-col justify-between border border-white/15 p-7 transition-colors duration-150 hover:border-beat-red hover:bg-beat-red" data-id="element-89" data-mp="3gfqpia1m2kq2">
              <Instagram size={26} className="mb-16 text-beat-red transition-colors duration-150 group-hover:text-white" data-id="element-90" data-mp="2fh5tq4qh9xoe" />
              <div data-id="element-91" data-mp="26ituxffgjtkv">
                <h3 className="text-2xl font-black uppercase tracking-[-0.01em]" data-id="element-92" data-mp="26ic1eqk6jtgn">
                  Follow
                </h3>
                <p className="mt-2 flex items-center gap-2 text-sm uppercase tracking-[0.14em] text-white/60 transition-colors duration-150 group-hover:text-white/80" data-id="element-93" data-mp="2alqilkjuufvo">
                  @beatyourbest_
                  <ArrowUpRight size={16} data-id="element-94" data-mp="21k0qsdm29exd" />
                </p>
              </div>
            </motion.a>

            <NotifyForm data-id="element-95" data-mp="3qz8az2ql84vp" />
            <StockForm data-id="element-96" data-mp="3qwm65av303h6" />
          </motion.div>
        </div>
      </section>

      {/* ── 09: CLOSING ──────────────────────────────────────── */}
      <section className="bg-beat-red px-5 py-28 md:px-10 md:py-40" data-id="element-97" data-mp="1kb7xdbe3vgbv">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={stagger} className="mx-auto max-w-[1400px] flex flex-col items-center text-center" data-id="element-98" data-mp="1fbbvbhoyxyyy">
          <motion.h2 variants={rise} className="text-[12vw] font-black uppercase leading-[0.85] tracking-[-0.04em] md:text-[8vw]" data-id="element-99" data-mp="1p7yapqyizxtl">
            Don't waste
            <br data-id="element-100" data-mp="1y1bexp21iluz" />
            a heartbeat.
          </motion.h2>
          <motion.div variants={rise} className="mt-16" data-id="element-101" data-mp="2cz3uuibi1c9p">
            <BeatMark className="w-32 md:w-48" data-id="element-102" data-mp="2cwhkkax84ins" />
          </motion.div>
        </motion.div>
      </section>

      {/* ── FOOTER ───────────────────────────────────────────── */}
      <footer className="px-5 py-14 md:px-10" data-id="element-103" data-mp="il2vzxfy8p9m">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-10 border-t border-white/10 pt-10 md:flex-row md:items-center md:justify-between" data-id="element-104" data-mp="dm9gjzh3qo6t">
          <BeatMark className="w-28" data-id="element-105" data-mp="26p8ig91ns8wr" />
          <div className="flex flex-col gap-3 text-xs uppercase tracking-[0.18em] text-white/40 md:flex-row md:items-center md:gap-8" data-id="element-106" data-mp="21s8b7ut2p042">
            <a href={`mailto:${CONTACT_EMAIL}`} className="transition-colors duration-150 hover:text-white" data-id="element-107" data-mp="2gftgnvdf7bf5">
              {CONTACT_EMAIL}
            </a>
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="transition-colors duration-150 hover:text-white" data-id="element-108" data-mp="1nt8l0ipwwd5s">
              Instagram
            </a>
            <p data-id="element-109" data-mp="1xo0lpvesjg4s">© {new Date().getFullYear()} BEAT Soda</p>
          </div>
        </div>
      </footer>
    </div>;
}
function BeatMark({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`relative overflow-hidden aspect-[5.2/1] ${className}`} data-id="element-110" data-mp="397ms79ijb8q0">
      <img src={LOGO_URL} alt="BEAT Soda" className="absolute left-1/2 top-1/2 w-[165%] max-w-none -translate-x-1/2 -translate-y-1/2" data-id="element-111" data-mp="345xf7obr4kza" />
    </div>;
}
function Marquee() {
  const line = 'Good taste — Good people — Good times — ';
  return <div className="overflow-hidden bg-beat-red py-4" data-id="element-112" data-mp="32q1uqojn5eii">
      <motion.div animate={{
      x: ['0%', '-50%']
    }} transition={{
      duration: 22,
      ease: 'linear',
      repeat: Infinity
    }} className="flex w-max whitespace-nowrap" data-id="element-113" data-mp="32rmpae5ygxgd">
        {[0, 1].map(group => <span key={group} className="text-sm font-black uppercase tracking-[0.28em] text-white md:text-base" data-id="element-114" data-mp="39d7b0i3r468">
            {line.repeat(6)}
          </span>)}
      </motion.div>
    </div>;
}
function Moment({
  src,
  alt,
  label,
  isVideo = false
}: {
  src: string;
  alt: string;
  label: string;
  isVideo?: boolean;
}) {
  return <section className="relative h-[80vh] w-full overflow-hidden md:h-screen" data-id="element-115" data-mp="m1frumxv74lr">
      {isVideo ? <motion.video src={src} autoPlay loop muted playsInline initial={{
      opacity: 0,
      scale: 1.04
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-10%'
    }} transition={{
      duration: 1.1,
      ease: EASE
    }} className="h-full w-full object-cover" data-id="element-116" data-mp="vw37agopimrk" /> : <motion.img src={src} alt={alt} initial={{
      opacity: 0,
      scale: 1.04
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-10%'
    }} transition={{
      duration: 1.1,
      ease: EASE
    }} className="h-full w-full object-cover" data-id="element-117" data-mp="84xw4etpoinl" />}
      <p className="absolute bottom-6 left-5 text-[11px] font-bold uppercase tracking-[0.28em] text-white/80 md:left-10" data-id="element-118" data-mp="3b8ub4zh2rc6p">
        {label}
      </p>
    </section>;
}
function PeopleItem({
  title,
  copy
}: {
  title: string;
  copy: string;
}) {
  return <motion.div variants={rise} data-id="element-119" data-mp="3q6mlzebofcek">
      <h3 className="text-4xl font-black uppercase tracking-[-0.02em] md:text-5xl" data-id="element-120" data-mp="3q5v2v2z9n756">
        {title}
        <span className="text-beat-red" data-id="element-121" data-mp="2sk744bfc8cqh">.</span>
      </h3>
      <p className="mt-4 max-w-xs text-base leading-relaxed text-black/60" data-id="element-122" data-mp="2xi8p51wbqm4l">
        {copy}
      </p>
    </motion.div>;
}
async function sendToBeat(payload: Record<string, string>) {
  const response = await fetch('https://api.web3forms.com/submit', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      access_key: WEB3FORMS_KEY,
      from_name: 'BEAT Website',
      to: CONTACT_EMAIL,
      ...payload
    })
  });
  return response.ok;
}
function NotifyForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!email) return;
    setStatus('loading');
    const ok = await sendToBeat({
      subject: 'BEAT — new launch signup',
      email,
      message: `New launch signup.\n\nEmail: ${email}`
    }).catch(() => false);
    setStatus(ok ? 'success' : 'error');
    if (ok) setEmail('');
  };
  return <motion.div variants={rise} className="flex flex-col justify-between border border-white/15 p-7" data-id="element-123" data-mp="yzvt61hdosui">
      <p className="mb-16 text-[11px] font-bold uppercase tracking-[0.28em] text-beat-red" data-id="element-124" data-mp="1cy3qwbm8ny6q">
        Launch
      </p>
      <div data-id="element-125" data-mp="3erjndp50c79m">
        <h3 className="text-2xl font-black uppercase tracking-[-0.01em]" data-id="element-126" data-mp="3er1ftwcwa6me">
          Be first
        </h3>
        {status === 'success' ? <p className="mt-4 flex items-center gap-2 text-sm font-bold uppercase tracking-[0.14em] text-beat-red" data-id="element-127" data-mp="39u1bbpvp1bxe">
            <Check size={16} data-id="element-128" data-mp="1pciojabmdnn1" /> You're on the list
          </p> : <form onSubmit={handleSubmit} className="mt-4 flex flex-col gap-3" data-id="element-129" data-mp="1u87i8x0ykabf">
            <input type="email" required value={email} onChange={event => setEmail(event.target.value)} placeholder="Your email" disabled={status === 'loading'} className="w-full border-b border-white/25 bg-transparent pb-2 text-sm text-white placeholder:text-white/40 focus:border-beat-red focus:outline-none disabled:opacity-50" data-id="element-130" data-mp="1fle620mqjkng" />
            <button type="submit" disabled={status === 'loading'} className="self-start text-sm font-bold uppercase tracking-[0.18em] text-white transition-colors duration-150 hover:text-beat-red disabled:opacity-50" data-id="element-131" data-mp="wnuzd3nr2e47">
              {status === 'loading' ? 'Sending…' : 'Notify me →'}
            </button>
            {status === 'error' && <p className="text-xs uppercase tracking-[0.14em] text-white/50" data-id="element-132" data-mp="2ufmb79os7ryq">
                Didn't go through — try again.
              </p>}
          </form>}
      </div>
    </motion.div>;
}
function StockForm() {
  const [form, setForm] = useState({
    company: '',
    email: '',
    notes: ''
  });
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!form.company || !form.email) return;
    setStatus('loading');
    const ok = await sendToBeat({
      subject: 'BEAT — new stockist enquiry',
      email: form.email,
      company: form.company,
      notes: form.notes || 'No notes',
      message: `New stockist enquiry.\n\nCompany: ${form.company}\nEmail: ${form.email}\nNotes: ${form.notes || 'No notes'}`
    }).catch(() => false);
    setStatus(ok ? 'success' : 'error');
    if (ok) setForm({
      company: '',
      email: '',
      notes: ''
    });
  };
  return <motion.div variants={rise} className="flex flex-col justify-between border border-white/15 p-7" data-id="element-133" data-mp="1ipg68br3a9g9">
      <p className="mb-16 text-[11px] font-bold uppercase tracking-[0.28em] text-beat-red" data-id="element-134" data-mp="1mogp1u9khc39">
        Trade
      </p>
      <div data-id="element-135" data-mp="1rn0bdvs2opw5">
        <h3 className="text-2xl font-black uppercase tracking-[-0.01em]" data-id="element-136" data-mp="1rmqle8712iqg">
          Stock BEAT
        </h3>
        {status === 'success' ? <p className="mt-4 flex items-center gap-2 text-sm font-bold uppercase tracking-[0.14em] text-beat-red" data-id="element-137" data-mp="21m90obbztgc6">
            <Check size={16} data-id="element-138" data-mp="26eiyedjcnkp0" /> We'll be in touch
          </p> : <form onSubmit={handleSubmit} className="mt-4 flex flex-col gap-3" data-id="element-139" data-mp="2afug7wvzf1mn">
            <input type="text" required value={form.company} onChange={event => setForm({
          ...form,
          company: event.target.value
        })} placeholder="Venue or company" disabled={status === 'loading'} className="w-full border-b border-white/25 bg-transparent pb-2 text-sm text-white placeholder:text-white/40 focus:border-beat-red focus:outline-none disabled:opacity-50" data-id="element-140" data-mp="2fexm1jjsdbvo" />
            <input type="email" required value={form.email} onChange={event => setForm({
          ...form,
          email: event.target.value
        })} placeholder="Your email" disabled={status === 'loading'} className="w-full border-b border-white/25 bg-transparent pb-2 text-sm text-white placeholder:text-white/40 focus:border-beat-red focus:outline-none disabled:opacity-50" data-id="element-141" data-mp="207lj1xw60piq" />
            <textarea rows={2} value={form.notes} onChange={event => setForm({
          ...form,
          notes: event.target.value
        })} placeholder="Volumes, timing, anything else" disabled={status === 'loading'} className="w-full resize-none border-b border-white/25 bg-transparent pb-2 text-sm text-white placeholder:text-white/40 focus:border-beat-red focus:outline-none disabled:opacity-50" data-id="element-142" data-mp="ovcbkaghz1jv" />
            <button type="submit" disabled={status === 'loading'} className="self-start text-sm font-bold uppercase tracking-[0.18em] text-white transition-colors duration-150 hover:text-beat-red disabled:opacity-50" data-id="element-143" data-mp="xf9cqhjpmcql">
              {status === 'loading' ? 'Sending…' : 'Send enquiry →'}
            </button>
            {status === 'error' && <p className="text-xs uppercase tracking-[0.14em] text-white/50" data-id="element-144" data-mp="38bhqr6luzj64">
                Didn't go through — try again.
              </p>}
          </form>}
      </div>
    </motion.div>;
}